<template>
    <transition name="slide" :duration="{ enter: 1000, leave: 300 }">
        <div class="tab-column tab-item" v-show="isActive"><slot></slot></div>
    </transition>
</template>
<script>
    export default {
        props: {
            name: { required: true },
            selected: { default: false },
            image: { required: false },
        },
        data() {
            return {
                isActive: false,
            }
        },
        computed: {
            href() {
                return '#' + this.name.toLowerCase().replace(/ /g, '-')
            },
            imageTag() {
                return '<img src="' + this.image + '" alt="' + this.name + '" class="tab-image" />'
            }
        },
        mounted() {
            this.isActive = this.selected
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/src/components/Tabs/TabItem.vue